export default __webpack_public_path__ + "static/media/warning.9ae472f0.svg";